/**
 * Reads the comma-separated list of facet handles that should be hidden for
 * the current collection from `data-nosto-hidden-facets` on the Nosto section
 * root. The Liquid template renders this attribute from
 * `collection.metafields.custom.nosto_hidden_facets` so merchants can force
 * specific facets off per collection: scoped PLP filter
 * visibility override).
 *
 * Returns an empty set when the attribute is absent or empty — callers can
 * treat the result as authoritative.
 */
export function resolveHiddenFacetsForCollection(): Set<string> {
  if (typeof document === "undefined") {
    return new Set()
  }
  const root = document.querySelector('[data-section-type="nosto-collection"]')
  const raw = root?.getAttribute("data-nosto-hidden-facets") ?? ""
  return new Set(
    raw
      .split(",")
      .map(s => s.trim().toLowerCase())
      .filter(Boolean)
  )
}
